<template>
  <div>
    <FormField
      class="mt-5"
      id="manualProductTitle"
      :modelValue="modelValue.manualProductTitle"
      @update:modelValue="updateField('manualProductTitle', $event)"
      label="Nom du produit"
      name="manualProductTitle"
      required
    />

    <FormField
      class="mt-5"
      id="manualProductPrice"
      :modelValue="modelValue.manualProductPrice"
      @update:modelValue="updateField('manualProductPrice', $event)"
      label="Prix du produit"
      name="manualProductPrice"
      trailingAddOns="EUR"
      type="number"
      required
    />

    <FormField
      class="mt-5"
      id="manualProductVendor"
      :modelValue="modelValue.manualProductVendor"
      @update:modelValue="updateField('manualProductVendor', $event)"
      label="Produit acheté chez"
      name="manualProductVendor"
      required
    />

    <FormField
      class="mt-5"
      id="manualProductReferenceId"
      :modelValue="modelValue.manualProductReferenceId"
      @update:modelValue="updateField('manualProductReferenceId', $event)"
      label="Numéro de série du produit"
      name="manualProductReferenceId"
      required
    />

    <FormField
      id="purchaseDate"
      name="purchaseDate"
      class="mt-5"
      type="date"
      :modelValue="modelValue.manualProductPurchasedAt"
      @update:modelValue="updateField('manualProductPurchasedAt', $event)"
      label="Date d'achat du produit"
      required
    />
  </div>
</template>

<script>
import { FormField } from "@estaly/ui";

export const MANUAL_PRODUCT_FIELDS = [
  "manualProductTitle",
  "manualProductPrice",
  "manualProductVendor",
  "manualProductReferenceId",
  "manualProductPurchasedAt",
];

export const MANUAL_PRODUCT_FORM_DATA_KEYS = {
  manualProductTitle: "manual_product_title",
  manualProductPrice: "manual_product_price",
  manualProductVendor: "manual_product_vendor",
  manualProductReferenceId: "manual_product_reference_id",
  manualProductPurchasedAt: "manual_product_purchased_at",
};

export function emptyManualProductValues() {
  return MANUAL_PRODUCT_FIELDS.reduce((acc, key) => {
    acc[key] = null;
    return acc;
  }, {});
}

export default {
  components: {
    FormField,
  },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  methods: {
    updateField(field, value) {
      this.$emit("update:modelValue", {
        ...this.modelValue,
        [field]: value,
      });
    },
  },
};
</script>
